
type AppEnvironment = "production" | "staging" | "development";

const appEnv = process.env.APP_ENV as AppEnvironment | undefined;
const normalizedEnv: AppEnvironment | undefined = (
    appEnv === "production" || appEnv === "staging" || appEnv === "development"
) ? appEnv : undefined;

export const ENVIRONMENT: AppEnvironment = normalizedEnv || (
    process.env.NODE_ENV === "production" ? "production" : "development"
);
